import styled from 'styled-components'

import mediaQueries from 'components/media-queries'
import { datePicker as e2eClasses } from 'constants/e2eClasses'

export const DatePickerContainer = styled.div.attrs(() => ({
  className: e2eClasses.container
}))`
  display: flex;
  flex-direction: column;

  .DayPickerInput {
    width: 100%;
  }

  .DayPickerInput-OverlayWrapper {
    margin-top: 4px;

    .DayPickerInput-Overlay {
      box-shadow: none;
      width: max-content;
      z-index: 99;

      ${mediaQueries.mobile`
        width: auto;
      `};

      .DayPicker-wrapper {
        color: ${({ theme }) => theme.colors.doveGrayer};
        border: 1px solid ${({ theme }) => theme.colors.blue};
        font-family: ${({ theme }) => theme.fonts.regular};
        border-radius: 3px;
        font-size: 16px;

        ${mediaQueries.tablet`
          outline: none;
        `};

        .DayPicker-Month {
          margin: 22px 22px 0;
          border-collapse: unset;
          border-spacing: 0 5px;

          ${mediaQueries.mobile`
            padding: 22px;
            margin: 0;
          `};
        }

        .DayPicker-NavButton {
          width: 20px;
          height: 20px;
          top: 22px;
          background-size: 100%;
        }

        .DayPicker-Caption {
          position: relative;
          left: 14%;
          width: 75%;
        }

        @supports (-moz-appearance: none) {
          .DayPicker-Caption {
            margin-left: 30px;
          }
          .DayPicker-Month {
            display: block;
            margin: 22px 22px 0;
            border-collapse: unset;
            border-spacing: 0 5px;

            ${mediaQueries.mobile`
                padding: 22px;
                margin: 0;
              `};
          }
        }

        .DayPicker-Caption > div {
          color: ${({ theme }) => theme.colors.blue};
          font-size: 16px;
          text-align: center;
          font-family: ${({ theme }) => theme.fonts.bold};
        }

        .DayPicker-Weekday {
          font-family: ${({ theme }) => theme.fonts.bold};
          color: ${({ theme }) => theme.colors.doveGray};
        }

        .DayPicker-Day--selected {
          color: ${({ theme }) => theme.colors.white} !important;
        }

        .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
          background-color: ${({ theme }) => theme.colors.blue};

          &.DayPicker-Day--start {
            font-family: ${({ theme }) => theme.fonts.bold};
          }

          &.DayPicker-Day--start,
          &.DayPicker-Day--first,
          &:first-child {
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
          }

          &.DayPicker-Day--end {
            font-family: ${({ theme }) => theme.fonts.bold};
          }

          &.DayPicker-Day--end,
          &.DayPicker-Day--last,
          &:last-child {
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
          }
        }

        .DayPicker-Day
          :not(.DayPicker-Day--disabled)
          :not(.DayPicker-Day--selected)
          :not(.DayPicker-Day--outside)
          :hover {
          background-color: ${({ theme }) => theme.colors.blueLight};
          border-radius: 3px;
        }

        .DayPicker-Day--disabled {
          pointer-events: none;
          color: ${({ theme }) => theme.colors.accessibleGrey};
        }

        .DayPicker-Day {
          border-radius: 0;
          padding: 10px;

          &:focus {
            border-radius: 3px;
            outline: none;
          }
        }

        .DayPicker-Day--today:not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled) {
          color: ${({ theme }) => theme.colors.blue};
          font-family: ${({ theme }) => theme.fonts.bold};

          &::before {
            content: '•';
            position: absolute;
            margin-top: 10px;
            text-align: center;
            width: 1.1em;
          }
        }
      }
    }

    .datePickerFormCustom {
      .DayPicker-wrapper {
        .DayPicker-Day {
          padding: 10px 18px;
        }
      }
    }
  }
`

export const DatePickerFromContainer = styled.div`
  width: ${({ width, theme }) =>
    theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true'
      ? ''
      : width || '150px'};

  ${mediaQueries.tablet`
  width: 50%;
  `};
`

export const DatePickerToContainer = styled.div`
  width: ${({ width, theme }) =>
    theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true'
      ? ''
      : width || '150px'};
  margin-left: ${({ theme }) =>
    theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true' ? '' : '30px'};

  .DayPickerInput-Overlay {
    margin-left: -176px;
  }
  ${mediaQueries.tablet`
  width: 50%;
  `};
`

export const DatePickerTitle = styled.label.attrs(props => ({
  className: e2eClasses.title,
  htmlFor: props.forId || 'datepicker'
}))`
  color: ${({ theme }) => theme.colors.doveGray};
  padding: 14px 0;
  display: flex;
  font-size: 14px;
  font-family: ${({ semiBold, theme }) => (semiBold ? theme.fonts.semiBold : theme.fonts.regular)};

  ${mediaQueries.tablet/*Hides visually but not for screen-readers*/ `
    ${({ showTitle }) =>
      !showTitle &&
      `
        clip: rect(0 0 0 0); 
        clip-path: inset(50%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap; 
        width: 1px;
      `}
  `}
`

export const DayPickerResponsive = styled.div`
  .DayPicker {
    width: 100%;
  }

  .DayPicker-wrapper {
    color: ${({ theme }) => theme.colors.doveGrayer};
    font-size: 16px;
    font-family: ${({ theme }) => theme.fonts.regular};
    width: 100%;
    outline: none;

    .DayPicker {
      width: 100%;
    }

    .DayPicker-Months {
      width: 100%;
    }

    .DayPicker-Month {
      margin: 22px 22px 0;
      border-collapse: unset;
      border-spacing: 0 5px;
      width: 100%;

      ${mediaQueries.mobile`
        padding: 22px;
        margin: 0;
      `};
    }

    .DayPicker-NavButton {
      width: 20px;
      height: 20px;
      top: 22px;
      background-size: 100%;
    }

    .DayPicker-Caption {
      position: relative;
      text-align: center;
    }

    .DayPicker-Caption > div {
      color: ${({ theme }) => theme.colors.blue};
      font-size: 16px;
      text-align: center;
      font-family: ${({ theme }) => theme.fonts.bold};
    }

    .DayPicker-Weekday {
      font-family: ${({ theme }) => theme.fonts.bold};
    }

    .DayPicker-Day--selected {
      color: ${({ theme }) => theme.colors.white} !important;
    }

    .DayPicker-Day--disabled {
      pointer-events: none;
    }

    .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
      background-color: ${({ theme }) => theme.colors.blue};

      &.DayPicker-Day--start {
        font-family: ${({ theme }) => theme.fonts.bold};
      }

      &.DayPicker-Day--start,
      &.DayPicker-Day--first,
      &:first-child {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }

      &.DayPicker-Day--end {
        font-family: ${({ theme }) => theme.fonts.bold};
      }

      &.DayPicker-Day--end,
      &.DayPicker-Day--last,
      &:last-child {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }
    }

    .DayPicker-Day
      :not(.DayPicker-Day--disabled)
      :not(.DayPicker-Day--selected)
      :not(.DayPicker-Day--outside)
      :hover {
      background-color: ${({ theme }) => theme.colors.blueLight};
      border-radius: 3px;
    }

    .DayPicker-Day {
      border-radius: 0;
      padding: 10px;

      &:focus {
        border-radius: 3px;
        outline: none;
      }
    }

    .DayPicker-Day--today:not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled) {
      color: ${({ theme }) => theme.colors.blue};
      font-family: ${({ theme }) => theme.fonts.bold};

      &::before {
        content: '•';
        position: absolute;
        margin-top: 10px;
        text-align: center;
        width: 1.1em;
      }
    }
  }
`

export const InputContainers = styled.div`
  display: flex;
  ${({ theme }) =>
    theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true' &&
    'flex-direction: column;'}
`
